import { memo } from 'react';

import { Text } from 'ui/Text';

interface CardExpirationProps {
  color: string;
  isCurrentMonth: boolean;
  month: number;
  year: number;
}

const CardExpiration = ({
  color,
  isCurrentMonth,
  month,
  year
}: CardExpirationProps) => (
  <Text
    textAlign='right'
    fontSize={{ base: '16px', lg: '18px' }}
    lineHeight={{ base: '24px', lg: '26px' }}
    color={color}
  >
    {`${isCurrentMonth ? 'Expiring soon' : 'EXP'} ${
      month < 10 ? `0${month}` : month
    }/${(String(year) ?? '00').slice(-2)}`}
  </Text>
);

export default memo(CardExpiration);
